module.exports = __webpack_public_path__ + "img/logo.369b56b8.jpg";